/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from "react";
import AuthenticationContext from "../../Store/Authentication-Context";
import { Card } from "react-bootstrap";
import ActionButtons from "../JobControl/ActionButton";
import { AppContext } from "../MainComponents/AppContext";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AgGridReact } from 'ag-grid-react';
import Axios from "axios";


const Step2 = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const { setAuthContext } = useContext(AuthenticationContext);
    const [appContext] = useContext(AppContext);
    const gridRef = useRef(null);
    const isEditRef = useRef(null);
    const isSelectedRef = useRef(null);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const validate = () => {
        if (selectedItems.length === 0) {
            setError("Please select any one item");
        }
        else {
            setError("");
            appContext.entraJob.selectedItems = selectedItems;
            props.nextStep();
        }
        
    };
    const columnDefs = [
        {
            headerCheckboxSelection: params => {
                // You can conditionally return true/false here
                return !isEditRef.current; // Custom logic
            },
            checkboxSelection: params => {
                const { data } = params;
                // Disable checkbox based on row data
                return !isEditRef.current && data?.jobId === 0;
            },
            width: 50,
        },
        { headerName: 'Name', flex: 1, field: 'serviceGroupName' },
        { headerName: 'Type', flex: 1, field: 'jobType' },
        {
            headerName: 'BP report',
            field: 'blueprint',
            flex: 1,
            minWidth:70,
            cellRenderer: params => (params.value ? <div> <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-check text-success"
                viewBox="0 0 16 16"
            >
                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
            </svg>
            </div> : <div><svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-x text-danger"
                viewBox="0 0 16 16"
            >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
            </svg></div>)
        },
        {
            headerName: 'Diff Report',
            field: 'differenceReport',
            flex: 1,
            minWidth: 70,
            cellRenderer: params => (params.value ? <div> <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-check text-success"
                viewBox="0 0 16 16"
            >
                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
            </svg>
            </div> : <div><svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-x text-danger"
                viewBox="0 0 16 16"
            >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
            </svg></div>)
        },
        {
            headerName: 'Roll Back',
            field: 'restore',
            flex: 1,
            minWidth: 70,
            cellRenderer: params => (params.value ? <div> <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-check text-success"
                viewBox="0 0 16 16"
            >
                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
            </svg>
            </div> : <div><svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                fill="currentColor"
                className="bi bi-x text-danger"
                viewBox="0 0 16 16"
            >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
            </svg></div>)
        },
        {
            headerName: 'PPU',
            field: 'costPerUser',
            flex: 1,
            minWidth: 100,
            cellRenderer: params => (params.value !== null ? `${params.value.toFixed(2)}` : 'N/A')
        }
    ];

    async function getGaurdianDetails() {
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
        const data = await Axios.get(API_ROUTE + Routes.GET_GUARDIAN_SERVICE_GROUPS(orgId,sessionStorage.getItem('ManageTenantDomain')), config)
            .then((response) => {
                let result = JSON.parse(response.data);
                ////result = result.filter((item, index, self) =>
                ////    index === self.findIndex((t) => t.serviceGroupID === item.serviceGroupID)
                ////);
                //console.log(result)
                if (isEditRef.current) {
                    result = result.filter(item => isSelectedRef.current.includes(item.serviceGroupID))
                }
                else {
                    result=result.filter((item, index, self) => item.jobId === 0 );
                }
                setRowData(result)
                return result;
            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                return reason;
            });

        return data;
    }
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows(); 
        const serviceGroupIDs = selectedRows.map(item => item.serviceGroupID);
        setSelectedItems(serviceGroupIDs);
        if (selectedRows.length !== 0) {
            setError("");
        }
    };
    useEffect(() => {
        getGaurdianDetails();
    }, []);

    useEffect(() => {
        setSelectedItems(appContext.entraJob.selectedItems)
        isSelectedRef.current=appContext.entraJob.selectedItems
        isEditRef.current = appContext.entraJob.isEditJob
    }, [appContext.entraJob]);
    const onGridReady = (params) => {
        gridRef.current = params.api;

        // Wait for data to render before selecting
        setTimeout(() => {
            params.api.forEachNode(node => {
                if (isSelectedRef.current.includes(node.data.serviceGroupID)) {
                    node.setSelected(true);
                }
            });
        }, 1000);
    };
    return (
        <Card>
            <Card.Header>
                <span id="TitleLabel" className="SectionTitle">Select Items </span>
            </Card.Header>
            <Card.Body>
                <span id="WizardRequiredFieldValidatorEntraSelectItems" className='mb-2' style={{ color: "red", display: 'block', width: '100%', textAlign: 'center' }} >{error}</span>
                <div className="ag-theme-alpine p-1 pt-0" style={{ width: "100%", height: "307px", borderCollapse: "collapse" }} >
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        rowSelection={{ mode: 'multiRow' }}
                        getRowNodeId={data => data.serviceGroupID.toString()}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                    />
                </div>
            </Card.Body>
            <Card.Footer>
                <table cellSpacing="5" cellPadding="5" align="right">
                    <tbody>
                        <tr>
                            <td >
                                <ActionButtons {...props} nextStep={validate} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Footer>
        </Card>
    );
}
export default Step2;